<div [formGroup]="form" class="flex flex-column gap-2">
  <label [attr.for]="item.key" class="font-semibold"
    >{{ item.label || '' | translate }}
    <span class="asterisk" *ngIf="item.required">*</span>
  </label>

  <p-calendar
    [required]="item.required || true"
    [keepInvalid]="true"
    styleClass="w-full"
    [placeholder]="item.placeholder || '' | translate"
    [iconPos]="item.config?.iconPos || 'left'"
    [showIcon]="item.config?.showIcon || true"
    [icon]="item.config?.icon || 'pi pi-calendar'"
    ngClass="{{ isInValid ? 'ng-invalid ng-dirty' : '' }}"
    [dateFormat]="item.config?.dateFormat || 'dd/mm/yy'"
    [formControlName]="item.key"
  ></p-calendar>

  <small
    class="p-error block font-italic"
    *ngIf="isInValid && hasError('required')"
  >
    {{
      item.errorMessage?.required?.message || ''
        | translate : item.errorMessage?.required?.params
    }}
  </small>
</div>
